<template>
  <div id="orderlist" style="width: 100%;height: 100%">

    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" style="padding-top:0;margin-top:0">
        <el-col :xl="{span:5}" :lg="{span:7}" :md="{span:10}" :sm="{span:10}" :xs="{span:10}">
          <el-form-item label="客户：">
            <el-select v-model="searchForm.TC_ID" filterable placeholder="请选择" clearable @change="changeCustomer">
              <el-option v-for="item in customers" :key="item.TC_ID" :label="item.AB_NAME" :value="item.TC_ID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xl="{span:5}" :lg="{span:7}" :md="{span:10}" :sm="{span:10}" :xs="{span:10}">
          <el-form-item label="项目点：">
            <el-select v-model="searchForm.PROJECT" filterable placeholder="请选择" clearable @change="changeProject">
              <el-option v-for="item in points" :key="item.value" :label="item.AB_NAME" :value="item.ID">
                <span style="float: left">{{ item.AB_NAME }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xl="{span:5}" :lg="{span:7}" :md="{span:10}" :sm="{span:10}" :xs="{span:10}">
          <el-form-item label="送货日期：">
            <el-date-picker v-model="searchForm.SEND_DAY" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="changeSendDay">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xl="{span:5}" :lg="{span:7}" :md="{span:10}" :sm="{span:10}" :xs="{span:10}">
          <el-form-item label="月份：">
            <el-date-picker v-model="searchForm.MONTH" type="month" placeholder="选择月"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-form-item>
            <el-button v-preventReClick id="search" @click="handleSearch()">筛选</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item>
            <el-button v-preventReClick :loading="loading1" @click="exportProfit()">导出利润报表</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item>
            <el-button v-preventReClick :loading="loading2" @click="exportSingleLoss()">导出单品亏损表</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <!-- 导出利润表的弹框 -->
    <el-dialog title="导出利润报表" width="500px" center :visible.sync="exportDetailVisible" @close="exportDetailVisible = false">
      <el-form :model="exportDetailForm" ref="exportDetailForm">
        <el-form-item label="选择日期：" label-width="120px">
          <el-date-picker style="width: 300px;" v-model="exportDetailForm.START_END" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" clearable>
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-preventReClick @click="exportDetailVisible = false">取 消</el-button>
        <el-button v-preventReClick @click="submitExport">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出单品亏损表的弹框 -->
    <el-dialog title="导出单品亏损表" center :visible.sync="simpleLossVisible" @close="simpleLossVisible = false" width="580px">

      <el-form :model="simpleLossForm" ref="simpleLossForm">
        <el-form-item label="日期范围：" label-width="180px">
        <el-date-picker style="width: 300px;" v-model="simpleLossForm.START_END" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" clearable>
        </el-date-picker>
      </el-form-item>

        <el-form-item label="利润百分比：" label-width="180px">
          <el-input  style="width: 300px;" placeholder="请利润百分比" v-model="simpleLossForm.MAX_RATE" clearable ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-preventReClick @click="simpleLossVisible = false">取 消</el-button>
        <el-button v-preventReClick @click="submitsimpleLoss">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col :span="4">
        <span>总收入：{{totalFee}}元</span>
      </el-col>
      <el-col :span="4">
        <span>总成本：{{totalCost}}元</span>
      </el-col>
      <el-col :span="4">
        <span>总利润：{{realMoney}}元</span>
      </el-col>
    </el-row>
    <el-row v-loading="loading">
      <el-col :span="24">
        <el-table :data="newOrderListData" border stripe show-summary style="width: 100%;margin-top:10px">
          <el-table-column type="index" width="45" min-width="30" label="序号"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="135"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
          <el-table-column prop="TOTAL_SUPPLIER_FEE" label="收入（元）" min-width="100"></el-table-column>
          <el-table-column prop="TOTAL_SUPPLIER_FEE" label="扣点后收入（元）" min-width="100" v-if="Number(MINIFU_ID) == 1574"></el-table-column>
          <el-table-column prop="TOTAL_COST" label="成本（元）" min-width="100"></el-table-column>
          <el-table-column prop="PROFIT" label="利润（元）" min-width="100"></el-table-column>
          <el-table-column prop="ORDER_TOTAL_COST" label="订购总成本（元）" min-width="100"></el-table-column>
          <el-table-column prop="ORDER_TOTAL_SUPPLIER_FEE" label="订购总收入（元）" min-width="100"></el-table-column>
          <el-table-column prop="PROFITS" label="订购利润（元）" min-width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button v-preventReClick type="text" size="small" icon="el-icon-view" @click="detail(scope.row)">查看</el-button>
              <el-button v-preventReClick type="text" size="small" icon="el-icon-download" @click="output(scope.row)">导出成本表</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>

import date from '@/assets/common/date';
import http from '@/assets/common/http';
import util from "@/assets/common/util";

export default {
  data() {
    return {
      // 导出利润表
      exportDetailVisible: false,
      exportDetailForm: {},
      loading1: false,
      loading: false,
      companys: [

      ],
      points: [

      ],
      newOrderListData: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      searchForm: {
        TC_ID: '',
        PROJECT: '',
        STATUS: '',
        MONTH: date(new Date(), '%F').slice(0, 7),
      },
      index: 0,
      customers: [],
      totalCost: 0,
      totalFee: 0,
      realMoney: 0,
      flag: 1,
      // 导出单品亏损表
      loading2: false,
      simpleLossVisible: false,
      simpleLossForm: {},
      MINIFU_ID: Number(sessionStorage.getItem('tcId')),
    };
  },
  created() {
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 15;

    this.queryNewOrderListData();
    this.queryTitle();
    if (this.searchForm.TC_ID) {
      this.queryProject();
    }
  },
  watch: {
    flag(newValue) {
      this.queryNewOrderListData();
    },
  },
  computed: {
    // 上一次的搜索结果和条件
    ORDERLIST_ALL() {
      return this.$store.state.ORDERLIST_ALL;
    },
  },
  methods: {
    // 导出利润表
    exportProfit() {
      this.exportDetailVisible = true;
    },
    // 导出模态框的确认
    submitExport() {
      this.loading1 = true;
      const data = {
        SERVICE_ID: '10042',
        OTYPE: 20,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.TC_ID) {
        data.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT) {
        data.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (!this.exportDetailForm.START_END) {
        this.$message.show({ text: '请选择起始时间', type: 'warning' });
        return false;
      }
      data.START_DAY = this.exportDetailForm.START_END[0];
      data.END_DAY = this.exportDetailForm.START_END[1];

      http.post(data).then((res) => {
        if (res.length === 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.loading1 = false;
          this.exportDetailVisible = false;
        } else {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
          this.loading1 = false;
          this.exportDetailVisible = false;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading1 = false;
      });
    },
    // 导出单品亏损表
    exportSingleLoss() {
      this.simpleLossVisible = true;
    },
    // 单品亏损模态框提交
    submitsimpleLoss() {
      if ((new Date(this.simpleLossForm.START_END[1]) - new Date(this.simpleLossForm.START_END[0])) / 86400000 > 31) {
        this.$message.show({ text: '选择的日期范围请不要大于31天', type: 'warning' });
        return;
      }
      this.loading2 = true;
      const data = {
        SERVICE_ID: '10011',
        OTYPE: 400,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.TC_ID) {
        data.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT) {
        data.PROJECT_ID = this.searchForm.PROJECT;
      }

      if (!(this.simpleLossForm.START_END != null && this.simpleLossForm.START_END.length == 2)) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return;
      }
      data.START_DAY = this.simpleLossForm.START_END[0];
      data.END_DAY = this.simpleLossForm.START_END[1];

      const reg = /^[0-9]*[1-9][0-9]*$/;
      if (!this.simpleLossForm.MAX_RATE) {
        this.$message.show({ text: '请输入利润百分比', type: 'warning' });
        return false;
      } if (!reg.test(this.simpleLossForm.MAX_RATE)) {
        this.$message.show({ text: '请输入正整数', type: 'warning' });
        return false;
      }
      data.MAX_RATE = Number(this.simpleLossForm.MAX_RATE);

      http.post(data).then((res) => {
        if (res.length === 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.loading2 = false;
          this.simpleLossVisible = false;
        } else {

          window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
          this.loading2 = false;
          this.simpleLossVisible = false;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading2 = false;
      });
    },
    changeCustomer(e) {
      this.searchForm.PROJECT = '';
      this.queryProject();
      this.flag++;
    },
    changeProject(e) {
      this.flag++;
    },
    changeSendDay(e) {
      this.flag++;
    },
    detail(row) {
      this.$router.push({ name: 'orderProfitDetail' });
      sessionStorage.setItem('orderId', row.ORDER_ID);
    },
    // 获取新订单列表
    queryNewOrderListData() {
      this.loading = true;
      const data = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SERVICE_ID: '10042',
        OTYPE: 6,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.TC_ID) {
        data.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT) {
        data.PROJECT_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.MONTH) {
        data.MONTH = date(this.searchForm.MONTH, '%F').slice(0, 7);
      }
      if (this.searchForm.SEND_DAY) {
        data.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
      }
      http.post(data).then((res) => {
        if (res.length != 0) {
          this.newOrderListData = res.length > 0 ? res[0].list : [];
          this.newOrderListData.forEach((item, index) => {
            item.PROFIT = Math.round((Number(item.TOTAL_SUPPLIER_FEE) - Number(item.TOTAL_COST)) * 100) / 100;
            item.PROFITS = Math.round((Number(item.ORDER_TOTAL_SUPPLIER_FEE) - Number(item.ORDER_TOTAL_COST)) * 100) / 100;
          });
          this.totalCount = res.length > 0 ? res[0].TOTAL_COUNT : [];
          this.loading = false;
          this.totalCost = res[0].TOTAL_COST;
          this.totalFee = res[0].TOTAL_FEE;
          this.realMoney = Math.round((Number(res[0].TOTAL_FEE) - Number(res[0].TOTAL_COST)) * 100) / 100;
        } else {
          this.totalCost = 0;
          this.totalFee = 0;
          this.realMoney = 0;
          this.newOrderListData = res;
          this.loading = false;
        }
        this.$store.dispatch(
          'ORDERLIST_OBJ_MSG',
          { CONDITIN: this.searchForm, CURRENT_PAGE: this.currentPage },
        );
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
    // 获取项目点信息列表
    queryProject() {
      if (!this.searchForm.TC_ID) {
        this.points = [];
        return false
      }
      const params = {
        SERVICE_ID: '10082',
        OTYPE: 6,
        TC_ID: this.searchForm.TC_ID,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        if (res.length != 0) {
          this.points = res;
        } else {
          this.points = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryTitle() {
      const params = {
        SERVICE_ID: '10082',
        OTYPE: 7,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
      };
      http.post(params).then((res) => {
        this.customers = res.length > 0 ? res : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    output(row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: row.ORDER_ID,
            SERVICE_ID: '10042',
            OTYPE: 8,
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          };
          http.post(params).then((result) => {
            window.location.href = result[0].FILE_PATH;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    handleCurrentChange() {
      this.queryNewOrderListData();
    },
    // 点击筛选按钮触发
    handleSearch() {
      this.currentPage = 1;
      this.queryNewOrderListData();
    },
  },
};
</script>
<style scoped></style>





// WEBPACK FOOTER //
// src/components/priceManagement/orderProfitAnalysis.vue